module.exports = __webpack_public_path__ + "img/gleam-hero_xl.6571c56.webp";